var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfMapPosition = function SvgPdfMapPosition(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.25 22.2v-1.73q-3.125-.322-5.262-2.458-2.136-2.138-2.457-5.262H1.8v-1.5h1.73q.322-3.125 2.458-5.261T11.25 3.53V1.8h1.5v1.73q3.125.322 5.261 2.459t2.458 5.261h1.73v1.5h-1.73q-.32 3.124-2.458 5.262-2.136 2.136-5.261 2.457V22.2zM12 19q2.9 0 4.95-2.05T19 12t-2.05-4.95T12 5Q9.099 5 7.05 7.05T5 12q0 2.9 2.05 4.95T12 19m0-3.5q-1.444 0-2.472-1.028T8.5 12t1.028-2.472T12 8.5t2.472 1.028T15.5 12t-1.028 2.472Q13.443 15.5 12 15.5m0-1.5q.824 0 1.412-.588Q14 12.826 14 12t-.588-1.412A1.93 1.93 0 0 0 12 10q-.825 0-1.413.588A1.93 1.93 0 0 0 10 12q0 .825.587 1.412Q11.175 14 12 14"
  })));
};
export default SvgPdfMapPosition;